import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum TagwallInvoiceKeys {
  description = 'description', // verbose description of the item (human parseable)
  sell = 'sell', // the sell price of the item
  paymentAmount = 'paymentAmount', // the payment amount of the item
}

export const tagwallInvoiceFileDataSchema = yup.object().shape({
  organizationLogoOverride: yup.string().nullable().optional(),
  contact: yup
    .object()
    .shape({
      name: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
    })
    .required(),
  organization: yup
    .object()
    .shape({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      addressLine2: yup.string().nullable().optional(),
      cityStateZip: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
      website: yup.string().nullable().optional(),
    })
    .required(),
  billTo: yup
    .object()
    .shape({
      clientNumber: yup.string().nullable().optional(),
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      addressLine2: yup.string().nullable().optional(),
      cityStateZip: yup.string().nullable().optional(),
    })
    .required(),
  invoiceNumber: yup.string().nullable().optional(),
  proposalNumber: yup.string().nullable().optional(),
  externalPurchaseOrderNumber: yup.string().nullable().optional(),
  terms: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  installAt: yup
    .object()
    .shape({
      company: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      addressLine2: yup.string().nullable().optional(),
      cityStateZip: yup.string().nullable().optional(),
    })
    .required(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        description: yup.string().nullable().optional(),
        sell: yup.string().nullable().optional(),
        paymentAmount: yup.string().nullable().optional(),
      }),
    )
    .required(),
  isProForma: yup.string().nullable().optional(),
  depositApplied: yup.string().nullable().optional(),
  showPaymentAmount: yup.string().nullable().optional(),
})

export type TagwallInvoiceFileData = yup.InferType<typeof tagwallInvoiceFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<TagwallInvoiceFileData>

export const tagwallInvoiceFileMappings: RequiredFileData = {
  organizationLogoOverride: '064b4480-0a8b-4e0f-a332-c9cfa4669575',
  contact: {
    name: '3952458d-fbb0-4e4f-a8ce-1f919817f01e',
    phoneNumber: 'a5224d6e-e1a8-4ca1-ac5c-025c67d5fd33',
  },
  organization: {
    companyName: '70580b87-fb6a-4a97-a10c-31004309dc9d',
    addressLine1: '2c7e898e-6e8a-4e64-86b4-b236304318b3',
    addressLine2: '4b0551c4-2f40-481f-b70d-c7643cb22eb1',
    cityStateZip: '15b68e08-dc14-4e74-b64c-a2071d7a880e',
    phoneNumber: 'b4849048-ae4e-45ed-bb01-2d5603435dca',
    website: 'd5babb87-8211-4b47-9eb4-4dee32aed64c',
  },
  billTo: {
    clientNumber: '1ac39249-c434-4a99-b0c2-4173b382c672',
    companyName: '8308bd9f-250d-4744-8371-f6875c01cfb8',
    addressLine1: 'b6966455-0e1c-4547-9d8f-152340429b47',
    addressLine2: 'adcd006a-ae5a-49c3-ae2f-ed856f24361f',
    cityStateZip: 'cee7abb2-1e96-4d9b-a7b7-6354beeb819f',
  },
  invoiceNumber: '4392ebca-da3f-4645-a4ca-f1bddfc21134',
  proposalNumber: 'cea424b8-b006-45d2-a391-5e46b00b9c4a',
  externalPurchaseOrderNumber: '09dadee8-fa24-4a1b-a390-00e33f7d1057',
  terms: '0ba12edd-f4c2-4964-a1e4-d44533d2c7db',
  date: '8c72d494-7982-4039-894d-b59317fa3af8',
  installAt: {
    company: 'd36fafc7-18df-4c72-9fac-5412db9abbfc',
    addressLine1: 'cc38d419-83a4-4251-a526-aaab18e2688d',
    addressLine2: '47ecac20-d192-433f-9754-4846fe72c58e',
    cityStateZip: '918c5d3f-eae7-456b-90a2-19471c0cb89c',
  },
  items: [
    {
      description: 'd45e0a22-0425-42e3-b41c-aab2493dd485',
      sell: 'a32031bb-b243-46fd-a185-9fb466fff027',
      paymentAmount: 'e26e7a57-8570-410b-9a8c-88e190a471fb',
    },
  ],
  isProForma: '64c66408-c3e9-4480-a5e2-7e55c95a29d5',
  depositApplied: '113d4ceb-6871-41df-99c6-3b351aa4abbe',
  showPaymentAmount: '8317b1ba-5f8e-4143-9eca-949753a5934b',
}
